import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/quoting/canned/$packageId")({
  beforeLoad: ({ params: { packageId } }) => {
    throw redirect({
      to: "/templates/quotes/$packageId",
      params: { packageId },
    })
  },
})
